import React, { act, useEffect } from 'react';
import { TriggerProps } from 'src/feature-app';
import {
	CitaVentaForm,
	MasInformacionForm,
	PresupuestoForm,
	StockForm,
	TestDriveForm,
	VOForm,
} from 'src/forms';

export function LeadActionTrigger({
	setSelectedJourney,
	action,
}: TriggerProps): JSX.Element {
	console.log('action', act);

	useEffect(() => {
		if (action === 'es-oneform--lead-test_drive')
			setSelectedJourney(<TestDriveForm />, true);
		else if (action === 'es-oneform--lead-presupuesto')
			setSelectedJourney(<PresupuestoForm />, true);
		else if (action === 'es-oneform--lead-mas_informacion')
			setSelectedJourney(<MasInformacionForm />, true);
		else if (action === 'es-oneform--lead-cita')
			setSelectedJourney(<CitaVentaForm />, true);
		else if (action === 'es-oneform--lead-stock')
			setSelectedJourney(<StockForm />, true);
		else if (action === 'es-oneform--lead-vo')
			setSelectedJourney(<VOForm />, true);
	}, []);

	return null;
}
